// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__1pX7W","top":"style_top__49Tl8","image":"style_image__91b_e","text":"style_text__jmcmZ","bottom":"style_bottom__RIubc"};